import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BoardChangelogItemLoader from "./board-changelog-item-loader";
import ChangelogList from "./changelog-list.vue";
import NotificationPopover from "@Shared/components/general/notification-popover";
import { LOAD_CHANGELOG } from "@Broker/@Modules/clients/board/store/board-actions";
import { mapActions, mapState } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogPopover",
  components: {
    NotificationPopover,
    ChangelogList,
    BoardChangelogItemLoader
  },
  props: {
    clientProfileId: {
      type: String,
      default: ""
    },
    boardId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      loadingMoreChangelog: false,
      limit: 10,
      shouldLoadMore: true,
      offset: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["clientProfileIdsWithChanges"])), mapState("AccountStore", ["userDetails"])), {}, {
    currentProfileLastChanges() {
      var _this$clientProfileId, _this$clientProfileId2;
      return (_this$clientProfileId = (_this$clientProfileId2 = this.clientProfileIdsWithChanges[this.clientProfileId]) == null ? void 0 : _this$clientProfileId2.changelog) != null ? _this$clientProfileId : [];
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_CHANGELOG])), {}, {
    async handleShowChangelog() {
      if (this.currentProfileLastChanges.length) return;
      this.loading = true;
      await this.loadChangelog();
      this.offset += this.limit;
      this.loading = false;
    },
    loadMore({
      target: {
        scrollTop,
        clientHeight,
        scrollHeight
      }
    }) {
      const scrolledToBottom = Math.ceil(scrollTop) + clientHeight >= scrollHeight;
      if (!scrolledToBottom) return;
      this.loadMoreChangelog();
    },
    async loadMoreChangelog() {
      if (!this.shouldLoadMore || this.loadingMoreChangelog) return;
      this.loadingMoreChangelog = true;
      await this.loadChangelog();
      this.offset += this.limit;
      this.loadingMoreChangelog = false;
    },
    async loadChangelog() {
      const {
        loadedMoreChangelog
      } = await this.LOAD_CHANGELOG({
        clientProfileId: this.clientProfileId,
        lastChanges: true,
        limit: this.limit,
        offset: this.offset
      });
      this.shouldLoadMore = loadedMoreChangelog;
    }
  })
});